import { ibkApi } from '@ibk/shared-config';
export var EmissorOrderPaymentMethod;
(function (EmissorOrderPaymentMethod) {
    EmissorOrderPaymentMethod["PIX"] = "PIX";
    EmissorOrderPaymentMethod["BANKSLIP"] = "BANKSLIP";
})(EmissorOrderPaymentMethod || (EmissorOrderPaymentMethod = {}));
export var EmissorOrderPaymentStatus;
(function (EmissorOrderPaymentStatus) {
    EmissorOrderPaymentStatus["PENDING"] = "PENDING";
    EmissorOrderPaymentStatus["CREATED"] = "CREATED";
})(EmissorOrderPaymentStatus || (EmissorOrderPaymentStatus = {}));
export const buildCreateOrderPaymentMutation = ({ contractId, orderId, paymentMethod, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/payments/${paymentMethod}`,
    method: 'POST',
});
export const transformCreateOrderPaymentResponse = (response) => response.result;
export const parseOrderPaymentPdfResponse = async (response) => {
    return response.ok ? response.blob() : response.json();
};
export const blobToBase64 = async (blob) => {
    const bytes = new Uint8Array(await blob.arrayBuffer());
    let binary = '';
    const chunkSize = 0x8000;
    for (let offset = 0; offset < bytes.length; offset += chunkSize) {
        binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
    }
    return btoa(binary);
};
export const buildGetOrderPaymentPdfQuery = ({ contractId, orderId, paymentMethod, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/payments/${paymentMethod}/pdf`,
    method: 'GET',
    responseHandler: parseOrderPaymentPdfResponse,
});
export const contractOrderPaymentApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        createEmissorOrderPayment: build.mutation({
            query: buildCreateOrderPaymentMutation,
            transformResponse: transformCreateOrderPaymentResponse,
        }),
        getEmissorOrderPaymentPdf: build.mutation({
            query: buildGetOrderPaymentPdfQuery,
            transformResponse: (response) => blobToBase64(response),
        }),
    }),
    overrideExisting: false,
});
export const { useCreateEmissorOrderPaymentMutation, useGetEmissorOrderPaymentPdfMutation } = contractOrderPaymentApi;
